(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-menu"]) return;
  try {
    
  // Handle tooltip on mobile devices for cart items
  document.addEventListener('DOMContentLoaded', function() {
    function initCartTooltips() {
      const tooltipTags = document.querySelectorAll('.cart-pre-arrival-tag--with-tooltip');
      
      tooltipTags.forEach(tag => {
        tag.addEventListener('click', function(e) {
          e.stopPropagation();
          e.preventDefault();
          
          // Toggle active state
          const isActive = this.classList.contains('is-active');
          
          // Close all other tooltips
          tooltipTags.forEach(t => t.classList.remove('is-active'));
          
          // Toggle current tooltip
          if (!isActive) {
            this.classList.add('is-active');
          }
        });
      });
    }
    
    // Initialize on load
    initCartTooltips();
    
    // Re-initialize when cart updates (Alpine.js mutation observer)
    const observer = new MutationObserver(function() {
      initCartTooltips();
    });
    
    const cartItems = document.querySelector('.cart__items-wrapper');
    if (cartItems) {
      observer.observe(cartItems, { childList: true, subtree: true });
    }
    
    // Close tooltip when clicking outside
    document.addEventListener('click', function() {
      document.querySelectorAll('.cart-pre-arrival-tag--with-tooltip').forEach(tag => {
        tag.classList.remove('is-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
